import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetInvitationConfigRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetInvitationConfigResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getInvitationConfig = (request: GetInvitationConfigRequest, options?: CashRequestOptions) =>
  post<GetInvitationConfigRequest, GetInvitationConfigResponse>('/2.0/cash/get-invitation-config', request, {
    ...options,
    rejectOnError: true,
  })
